import { useState } from 'react'
import { ScanLine } from 'lucide-react'
import BarcodeScanner from '../../components/BarcodeScanner'
import { findArea } from './inventoryShared'

// Scan a bin's label (a handheld scanner types it and presses Enter) or use
// the camera, instead of choosing the bin from a list. `validate(area)`
// returns a message when that bin can't be used here; `prefer(area)` picks
// between same-named bins at different locations.
export default function BinScan({ areas, locationId, onPick, validate, prefer, placeholder = 'Scan the bin label' }) {
  const [code, setCode] = useState('')
  const [error, setError] = useState('')
  const [camera, setCamera] = useState(false)

  const pick = (raw) => {
    const found = findArea(areas, raw, locationId, prefer)
    if (!found.area) { setError(found.error); return }
    const problem = validate ? validate(found.area) : ''
    if (problem) { setError(problem); return }
    setError('')
    setCode('')
    onPick(found.area)
  }

  return (
    <div className="bin-scan">
      <form className="bin-scan-row" onSubmit={(e) => { e.preventDefault(); pick(code) }}>
        <ScanLine size={15} aria-hidden="true" />
        <input value={code} onChange={(e) => { setCode(e.target.value); setError('') }} placeholder={placeholder} aria-label={placeholder} />
        <button type="button" className="ci-btn ci-btn-ghost ci-btn-sm" onClick={() => setCamera(true)}>Camera</button>
      </form>
      {error && <p className="scan-error" role="alert">{error}</p>}
      <BarcodeScanner open={camera} onClose={() => setCamera(false)} onScan={(c) => { setCamera(false); pick(c) }} />
    </div>
  )
}
